import { useNavigate } from 'react-router-dom'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { Plus, Tag } from 'lucide-react'

export function CreateWatchlistSection() {
  const navigate = useNavigate()

  const handleCreateClick = () => {
    navigate('/instagram/create-watchlist')
  }

  return (
    <div>
      <Card className="border border-slate-200/30 dark:border-slate-800/30">
        <CardHeader className="pb-4">
          <div className="flex items-center gap-3">
            <div className="p-2 rounded-lg bg-primary/10 flex-shrink-0">
              <Plus className="h-4 w-4 text-primary" />
            </div>
            <div>
              <CardTitle className="text-lg font-semibold">Create New Watchlist</CardTitle>
              <CardDescription className="text-sm mt-1">
                Build custom collections of accounts to track and analyze
              </CardDescription>
            </div>
          </div>
        </CardHeader>
        <CardContent>
          <div className="space-y-4">
            <div className="flex items-center gap-2 text-xs text-muted-foreground">
              <Tag className="h-3 w-3" />
              <span>Select accounts from your saved collection or browse global accounts</span>
            </div>

            <Button 
              onClick={handleCreateClick}
              className="w-full sm:w-auto"
            >
              <Plus className="h-4 w-4 mr-2" />
              Create New Watchlist
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  )
} 